import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BASE_MODULES, SHARED_IMPORTS } from 'src/app/constants/shared-imports';
import { CommonService } from 'src/Services/common.service';
import { AnalyticsService } from 'src/Services/gtag.service';
import { StorageService } from 'src/Services/session-storage.service';

@Component({
  standalone: true,
  selector: 'app-chat-loader',
  templateUrl: './chat-loader.component.html',
  styleUrls: ['./chat-loader.component.scss'],
  imports: [...BASE_MODULES, SHARED_IMPORTS.ngbTooltip]
})
export class ChatLoaderComponent implements OnInit{
  unreadGif: boolean = false;
  userLoggedIn = 'false';
  constructor(private route: Router, protected commonService: CommonService, private analyticsService: AnalyticsService,
    private storage: StorageService){

  }
  ngOnInit(){
    this.userLoggedIn = this.commonService.userLoggedIn;
    if(this.commonService.getisUnreadMessage()){
      this.unreadGif = true;
    }
    const profileData = this.commonService.getProfileData();
    if ( profileData?.length > 0) {
      window.parent.postMessage({ messageType: 'chatState', chatOpen: true }, "*");
      this.route.navigateByUrl('chat/landing');
      this.openFlora();
    }
  }
  openChatWindow(){
    if(this.commonService.getDisplay() !="" || this.storage.getLocalStorageItem('minimizeUrl')){
      window.parent.postMessage({ messageType: 'chatState', chatOpen: true }, "*");
      this.route.navigateByUrl(this.storage.getLocalStorageItem('minimizeUrl')?
      this.storage.getLocalStorageItem('minimizeUrl'): this.commonService.getDisplay() );
      this.openFlora();
    } else if(this.commonService.getiframeOpen() === 'true'){
      window.parent.postMessage({ messageType: 'chatState', chatOpen: true }, "*");
      this.route.navigateByUrl('liveChat/agentWindow');
      this.openFlora();
    }
    else {
      window.parent.postMessage({ messageType: 'chatState', chatOpen: true }, "*");
      this.route.navigateByUrl('chat/landing');
      this.openFlora();
    }
  }

  openAiChatWindow(){
    this.analyticsService.event('Ai Module' + '-' + this.commonService.getstorePageName(), {
      'event_category': 'Ai Help',
      'event_label': 'Ai Module Section opened',
      'value': 1,
      'bot_id': this.commonService.getstorePageName()
    });
    this.route.navigateByUrl('/aiHelp/aiLanding');
    parent.postMessage('AiExpand','*');

  }
  openFlora() {
 parent.postMessage('Expand', '*');
  }

  closeFlora() {
    if(this.commonService.getisAiModuleCalled())
    {parent.postMessage('AiBotclose','*');
  }
  else{
    parent.postMessage('Close', '*');
  }
  }
}
